import AuthService from "./auth.service";
import jwt_decode from 'jwt-decode';
import { refreshToken } from "../Actions/api";
import Cookies from 'js-cookie';
import store from "../store";
const axios = require("axios");

const instance = axios.create();

const { dispatch } = store;

instance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("JWToken");
    if (token) {
      config.headers["Authorization"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    return response
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      var token = Cookies.get("JWToken");
      var user = "";
      if(token){
        user = jwt_decode(token).uid;
      }
      await dispatch(refreshToken(user));
      return instance(originalRequest);
    }
    return Promise.reject(error);
  }
)

export default instance;
